import React, { useState, useEffect } from "react";
import Header from "./Header";
import Home from "./Home";
import Education from "./Education";
import Skills from "./Skills";
import Experience from "./Experience";
import FeedBack from "./FeedBack";
import Quotes from "./Quotes";
import Hobbies from "./Hobbies";
import Projects from "./Projects";
import Services from "./Services";
import Footer from "./Footer";
import Testimonails from "./Testimonails";

const Layout = () => {
  const [activeSection, setActiveSection] = useState("home");
  // const [isHeaderVisible, setIsHeaderVisible] = useState(true);

  useEffect(() => {
    const handleScroll = () => {
      const sections = document.querySelectorAll(".section");
      let currentSection = "home";

      sections.forEach((section) => {
        const rect = section.getBoundingClientRect();
        if (rect.top <= 150 && rect.bottom >= 150) {
          currentSection = section.id;
        }
      });

      setActiveSection(currentSection);
    };
    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <>
      <div className="bg-[#0f172a] ">
        <div className="flex flex-col lg:flex-row w-full">
          {/* Header Section */}
          <div
            className="lg:w-1/2 flex justify-center text-white lg:sticky lg:top-0 items-center lg:py-12 px-6 lg:px-24 h-screen"
            // style={{ zIndex: "auto" }}
          >
            <Header activeSection={activeSection} />
          </div>

          {/* Content Section */}
          <div className=" lg:w-1/2 w-full">
            <div
              id="home"
              className="section pr-6 lg:pr-24 p-8 pt-12 bg-[#0f172a] lg:min-h-screen flex flex-col justify-center"
            >
              <Home />
            </div>
            <div
              id="education"
              className="section md:pr-6 lg:pr-24 bg-[#0f172a]"
            >
              <Education />
            </div>
            <div
              id="experience"
              className="section md:pr-6 lg:pr-24 md:p-8 !pt-0 bg-[#0f172a]"
            >
              <Experience />
            </div>
            <div
              id="skills"
              className="section md:pr-6 lg:pr-24 md:p-8 !pt-0 bg-[#0f172a]"
            >
              <Skills />
            </div>
          </div>
        </div>
        <div
          id="projects"
          className="max-w-screen-xl mx-auto section md:p-8 bg-[#0f172a] mt-10 justify-center items-center"
        >
          <Projects />
        </div>
        <div
          id="services"
          className="max-w-screen-xl mx-auto section md:p-8 bg-[#0f172a] mt-10 justify-center items-center"
        >
          <Services />
        </div>
        <div
          id="testimonials"
          className="max-w-screen-xl mx-auto section md:p-8 bg-[#0f172a] mt-10 justify-center items-center"
        >
          <Testimonails />
        </div>
        <div
          id="hobbies"
          className="max-w-screen-xl mx-auto section md:p-8 bg-[#0f172a] mt-10 justify-center items-center"
        >
          <Hobbies />
        </div>
        <div
          id="quotes"
          className="max-w-screen-xl mx-auto section md:p-8 bg-[#0f172a] mt-10 justify-center items-center"
        >
          <Quotes />
        </div>
        <div
          id="feedback"
          className="max-w-screen-xl mx-auto section p-8 bg-[#0f172a] lg:mt-20 flex justify-center items-center"
        >
          <FeedBack />
        </div>

        <div className="w-full section md:p-8 bg-black mt-10 justify-center items-center">
          <Footer />
        </div>
      </div>
    </>
  );
};

export default Layout;
